/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { confirm } from '../fn/two-factor-controller/confirm';
import { Confirm$Params } from '../fn/two-factor-controller/confirm';
import { confirmRequired } from '../fn/two-factor-controller/confirm-required';
import { ConfirmRequired$Params } from '../fn/two-factor-controller/confirm-required';
import { disable } from '../fn/two-factor-controller/disable';
import { Disable$Params } from '../fn/two-factor-controller/disable';
import { setup } from '../fn/two-factor-controller/setup';
import { Setup$Params } from '../fn/two-factor-controller/setup';
import { setupRequired } from '../fn/two-factor-controller/setup-required';
import { SetupRequired$Params } from '../fn/two-factor-controller/setup-required';
import { TwoFactorConfirmResult } from '../models/two-factor-confirm-result';
import { TwoFactorDisableResult } from '../models/two-factor-disable-result';
import { TwoFactorRequiredConfirmResult } from '../models/two-factor-required-confirm-result';
import { TwoFactorSetupResult } from '../models/two-factor-setup-result';
import { TwoFactorVerificationResult } from '../models/two-factor-verification-result';
import { verify2fa } from '../fn/two-factor-controller/verify-2-fa';
import { Verify2fa$Params } from '../fn/two-factor-controller/verify-2-fa';

@Injectable({ providedIn: 'root' })
export class TwoFactorControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `twoFactorControllerConfirm()` */
  static readonly TwoFactorControllerConfirmPath = '/auth/2fa/confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirm$Response(params: Confirm$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorConfirmResult>> {
    return confirm(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `confirm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirm(params: Confirm$Params, context?: HttpContext): Observable<TwoFactorConfirmResult> {
    return this.confirm$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorConfirmResult>): TwoFactorConfirmResult => r.body)
    );
  }

  /** Path part for operation `twoFactorControllerDisable()` */
  static readonly TwoFactorControllerDisablePath = '/auth/2fa/disable';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disable()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disable$Response(params: Disable$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorDisableResult>> {
    return disable(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disable$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  disable(params: Disable$Params, context?: HttpContext): Observable<TwoFactorDisableResult> {
    return this.disable$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorDisableResult>): TwoFactorDisableResult => r.body)
    );
  }

  /** Path part for operation `twoFactorControllerSetup()` */
  static readonly TwoFactorControllerSetupPath = '/auth/2fa/setup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setup()` instead.
   *
   * This method doesn't expect any request body.
   */
  setup$Response(params?: Setup$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorSetupResult>> {
    return setup(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setup(params?: Setup$Params, context?: HttpContext): Observable<TwoFactorSetupResult> {
    return this.setup$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorSetupResult>): TwoFactorSetupResult => r.body)
    );
  }

  /** Path part for operation `twoFactorControllerConfirmRequired()` */
  static readonly TwoFactorControllerConfirmRequiredPath = '/auth/2fa/setup-required/confirm';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `confirmRequired()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmRequired$Response(params: ConfirmRequired$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorRequiredConfirmResult>> {
    return confirmRequired(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `confirmRequired$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  confirmRequired(params: ConfirmRequired$Params, context?: HttpContext): Observable<TwoFactorRequiredConfirmResult> {
    return this.confirmRequired$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorRequiredConfirmResult>): TwoFactorRequiredConfirmResult => r.body)
    );
  }

  /** Path part for operation `twoFactorControllerSetupRequired()` */
  static readonly TwoFactorControllerSetupRequiredPath = '/auth/2fa/setup-required/setup';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setupRequired()` instead.
   *
   * This method doesn't expect any request body.
   */
  setupRequired$Response(params: SetupRequired$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorSetupResult>> {
    return setupRequired(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `setupRequired$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  setupRequired(params: SetupRequired$Params, context?: HttpContext): Observable<TwoFactorSetupResult> {
    return this.setupRequired$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorSetupResult>): TwoFactorSetupResult => r.body)
    );
  }

  /** Path part for operation `twoFactorControllerVerify2Fa()` */
  static readonly TwoFactorControllerVerify2FaPath = '/auth/2fa/verify';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verify2fa()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verify2fa$Response(params: Verify2fa$Params, context?: HttpContext): Observable<StrictHttpResponse<TwoFactorVerificationResult>> {
    return verify2fa(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verify2fa$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verify2fa(params: Verify2fa$Params, context?: HttpContext): Observable<TwoFactorVerificationResult> {
    return this.verify2fa$Response(params, context).pipe(
      map((r: StrictHttpResponse<TwoFactorVerificationResult>): TwoFactorVerificationResult => r.body)
    );
  }

}
